// src/components/PkdSection.jsx
import React from "react";
import { ListChecks, Info } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

/* --- helpers --- */
const get = (obj, path, dflt = undefined) =>
  path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : dflt), obj);

const toCode = (x) =>
  [x?.kodDzial, x?.kodKlasa, x?.kodPodklasa].filter(Boolean).join(".") || "—";

const toOpis = (x) => x?.opis || "—";

/* Small monospace code pill (same vibe as other pills) */
const codePill = (text) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 8px",
      borderRadius: 999,
      border: "1px solid #e5e7eb",
      background: "#f7faff",
      color: "#1f2937",
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: 0.2,
      marginRight: 8,
    }}
  >
    <span style={{ fontFamily: "ui-monospace,SFMono-Regular,Menlo,monospace" }}>
      {text}
    </span>
  </span>
);

/* A simple list renderer that matches your cards typography */
function PkdList({ title, items = [] }) {
  if (!items.length) {
    return (
      <RowIcon icon={Info} label={title}>
        <em style={{ color: "#6b7280" }}>Brak danych</em>
      </RowIcon>
    );
  }

  return (
    <RowIcon icon={ListChecks} label={title}>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {items.map((x, i) => (
          <li key={i} style={{ padding: "4px 0", color: "#111827" }}>
            {codePill(mono(toCode(x)))}
            <span style={{ fontWeight: 600 }}>{toOpis(x)}</span>
          </li>
        ))}
      </ul>
    </RowIcon>
  );
}

/** --- Component --- */
export default function PkdSection({
  /** pass raw odpis if you have it */
  rawOdpis = null,
  /** or pass arrays directly */
  pkdMain = null,
  pkdOther = null,
  title = "PKD",
}) {
  const d3 = rawOdpis ? get(rawOdpis, "odpis.dane.dzial3", {}) : {};
  const mainArr =
    pkdMain ??
    get(d3, "przedmiotDzialalnosci.przedmiotPrzewazajacejDzialalnosci", []) ??
    [];
  const otherArr =
    pkdOther ??
    get(d3, "przedmiotDzialalnosci.przedmiotPozostalejDzialalnosci", []) ??
    [];

  const empty = !(Array.isArray(mainArr) && mainArr.length) && !(Array.isArray(otherArr) && otherArr.length);

  return (
    <Sekcja
      title={title}
      icon={ListChecks}
      titleStyle={{ fontSize: 18, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      {empty ? (
        <em style={{ color: "#6b7280" }}>Brak danych.</em>
      ) : (
        <div className="sectionGrid">
          <div className="fullRow">
            <PkdList title="Przeważająca działalność" items={Array.isArray(mainArr) ? mainArr : []} />
          </div>
          <div className="fullRow">
            <PkdList title="Pozostała działalność" items={Array.isArray(otherArr) ? otherArr : []} />
          </div>
        </div>
      )}
    </Sekcja>
  );
}
